<template>
  <BaseDialog
    :open="open"
    :disabled="busy"
    :data-testid="testId"
    @close="$emit('close')"
  >
    <template #title>
      {{ title }}
    </template>
    <p>{{ message }}</p>
    <p
      v-if="error"
      class="notice notice-danger mt-12"
      role="alert"
    >
      {{ error }}
    </p>
    <div
      class="mt-12"
      style="display:flex;gap:8px;justify-content:flex-end;"
    >
      <button
        class="btn"
        :disabled="busy"
        @click="$emit('close')"
      >
        Abbrechen
      </button>
      <button
        class="btn btn-warn"
        :disabled="busy"
        @click="$emit('confirm')"
      >
        <span
          v-if="busy"
          class="spinner"
          aria-hidden="true"
        /> Löschen
      </button>
    </div>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/BaseDialog.vue';

export default {
  name: 'DeleteConfirmDialog',
  components: { BaseDialog },
  props: {
    open: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    title: { type: String, default: 'Eintrag löschen?' },
    message: { type: String, default: 'Diese Aktion kann nicht rückgängig gemacht werden.' },
    testId: { type: String, default: 'delete-confirm-dialog' },
    error: { type: String, default: '' }
  },
  emits: ['close', 'confirm']
};
</script>
